/**
 * Interface for the request body to get product online check
 */
export interface ProductOnlineCheckRequest {
  fingerprint: string
}

/**
 * Interface for each product item in the response
 */
export interface ProductOnlineCheckItem {
  Id: number
  Name: string
  Description: string
}

/**
 * Interface for the product online check response
 */
export interface ProductOnlineCheckResponse {
  data: ProductOnlineCheckItem[]
}

/**
 * Error class for product online check errors
 */
export class ProductOnlineCheckError extends Error {
  code: string

  constructor(message: string, code: string) {
    super(message)
    this.name = 'ProductOnlineCheckError'
    this.code = code
  }
}

// ===== Report Types API Types =====

/**
 * Interface for the request body to get report types
 */
export interface ReportTypesRequest {
  fingerprint: string
}

/**
 * Interface for each report type item in the response
 */
export interface ReportTypeItem {
  Name: string
  Order: number
  Description: string
  AgencyRequired: boolean
  AgencyFilter: boolean
  ProductRequired: boolean
  ProductFilter: boolean
}

/**
 * Interface for the report types response
 */
export interface ReportTypesResponse {
  data: ReportTypeItem[]
}

/**
 * Error class for report types errors
 */
export class ReportTypesError extends Error {
  code: string

  constructor(message: string, code: string) {
    super(message)
    this.name = 'ReportTypesError'
    this.code = code
  }
}

// ===== Enum Report Online Check List API Types =====

/**
 * Interface for the request body to search enum report online check list
 */
export interface EnumReportOnlineCheckListRequest {
  enum_name: string        // Nombre del tipo reporte (e.g., "Agencias")
  initial_date: string     // Fecha inicial en formato ISO (e.g., "2025-12-14T00:00:00")
  final_date: string       // Fecha final en formato ISO (e.g., "2025-12-15T23:59:59")
  entity_id: number        // Id del valor seleccionado en el dropdown de product o agencia
  fingerprint: string      // Fingerprint del usuario (e.g., "admin")
}

/**
 * Interface for each item in the enum report response
 * Represents a financial flow entry with entity and balance information
 */
export interface EnumReportOnlineCheckListItem {
  Entidad: string
  Entradas: number
  Salidas: number
  Balance: number
}

/**
 * Interface for the enum report online check list response
 */
export interface EnumReportOnlineCheckListResponse {
  data: EnumReportOnlineCheckListItem[]
}

/**
 * Error class for enum report online check list errors
 */
export class EnumReportOnlineCheckListError extends Error {
  code: string

  constructor(message: string, code: string) {
    super(message)
    this.name = 'EnumReportOnlineCheckListError'
    this.code = code
  }
}

// ===== Location Line Check API Types =====

/**
 * Interface for the request body to get location line check
 */
export interface LocationLineCheckRequest {
  fingerprint: string
}

/**
 * Interface for each location line item in the response
 */
export interface LocationLineCheckItem {
  Id: number
  Name: string
}

/**
 * Interface for the location line check response
 */
export interface LocationLineCheckResponse {
  data: LocationLineCheckItem[]
}

/**
 * Error class for location line check errors
 */
export class LocationLineCheckError extends Error {
  code: string

  constructor(message: string, code: string) {
    super(message)
    this.name = 'LocationLineCheckError'
    this.code = code
  }
}
